import { render, staticRenderFns } from "./GridReclutados.vue?vue&type=template&id=1647ec7e&"
import script from "./GridReclutados.vue?vue&type=script&lang=js&"
export * from "./GridReclutados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports